import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20digital%20art%20illustration%20with%20warm%20romantic%20lighting%2C%20two%20anime%20characters%20silhouettes%20in%20urban%20night%20setting%2C%20dramatic%20bokeh%20city%20lights%20in%20background%2C%20rich%20warm%20golden%20and%20rose%20tones%2C%20emotional%20atmosphere%2C%20webtoon%20cinematic%20composition%2C%20soft%20glow%20effects%2C%20dreamy%20aesthetic%2C%20high%20contrast&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="韩漫网 免费观看下拉式韩漫 漫画韩漫网址"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50"></div>

      <div className="relative z-10 w-full h-full flex items-center px-4 md:px-8 lg:px-16">
        <div className="max-w-2xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            免费观看下拉式
            <br />
            韩漫漫画网站
            <br />
            尽在韩漫网
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-lg">
            无需下载即可畅读，网站稳定内容全面，是漫画爱好者探索新作的理想选择
          </p>
          <div className="mt-8 md:mt-10">
            <Link
              to="/category/love"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}